export default __webpack_public_path__ + "static/media/site_icon.69988783.png";